import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Container, Row } from 'reactstrap'
import './Home.scss'
import books from '../../data/book-data'

function Home() {
  const floridaSeries = books.slice(-2).reverse();

  return (
    <Container className="Home py-5">
      <h1 className="h1 text-center mb-5 text-dark">The Florida Series</h1>

      <Row className="align-items-center justify-content-center">
        {floridaSeries.map((item) => (
          <Col
            key={item.title}
            xs={12}
            md={6}
            className="d-flex flex-column align-items-center justify-content-center mb-5 mb-md-0">
            <Link to={`/books/${item.title}`}>
              <img
                className="book-cover h-100 rounded img-fluid mb-3"
                src={`/images/${item.image}`}
                alt={item.alt}
              />
            </Link>
            <h2 className="h2 text-center mb-3">{item.subtitle}</h2>
            <p className="lead mb-3 text-center text-dark">Available on Amazon in e-reader and paperback</p>
            <Button className="mt-2" target="_blank" tag="a" href={item.link} outline size="lg">Buy On Amazon</Button>
          </Col>
        ))}
      </Row>
    </Container>  )
}

export default Home
